import { createContext, useContext } from 'react';

export type RightSectionPanel = 'ai' | 'context' | 'help' | null;

export type AiPromptRequest = {
	prompt: string;
	subjectID?: string;
};

export type RightSectionApi = {
	slot: HTMLElement | null;
	panel: RightSectionPanel;
	hasAi: boolean;
	setHasContext: (hasContext: boolean) => void;
	openContext: () => void;
	openAi: (request?: AiPromptRequest) => void;
	close: () => void;
};

export const RightSectionContext = createContext<RightSectionApi | null>(null);

export function useRightSection() {
	return useContext(RightSectionContext);
}
